// NAV-FE-6 — the sidebar's count pills (docs/design/home.md §4,
// docs/design/mockups/prototipo-shell-v12.html `.b`). Every number is one the
// Home already serves: `needs_you_by_kind` (counted before the cut, NAV-BE-4)
// and `kpis.open_items.punch`. Tests and ITPs have no reader on the Home, so
// they carry no pill. Pure: no React, no request.

export const BADGE_KEYS = ['assets', 'inspections', 'handover', 'rfis', 'ncrs', 'punch'];

/** How long the shell trusts the counts it holds before reading the Home again. */
export const BADGES_MAX_AGE_MS = 60_000;

const count = (x) => {
  const n = Number(x);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

/** The six counts from a Home payload; null when there is no payload. */
export function badgesFromHome(home) {
  if (!home || typeof home !== 'object') return null;
  const byKind = home.needs_you_by_kind || {};
  return {
    assets: count(byKind.hold_release),
    inspections: count(byKind.inspection_upcoming),
    handover: count(byKind.handover_inspection_upcoming),
    rfis: count(byKind.rfi_unanswered),
    ncrs: count(byKind.ncr_my_turn),
    punch: count(home.kpis?.open_items?.punch),
  };
}

const TONES = { assets: 'hot', rfis: 'hot', ncrs: 'red' };

const plural = (n, one, many) => (n === 1 ? one : many);

const SENTENCES = {
  assets: (n) => `${n} ${plural(n, 'hold point', 'hold points')} waiting for your company`,
  inspections: (n) => `${n} ${plural(n, 'inspection', 'inspections')} this week where your company signs`,
  handover: (n) => `${n} handover ${plural(n, 'inspection', 'inspections')} this week`,
  rfis: (n) => `${n} ${plural(n, 'RFI', 'RFIs')} waiting for your company's answer`,
  ncrs: (n) => `${n} ${plural(n, 'NCR', 'NCRs')} waiting on your company`,
  punch: (n) => `${n} open punch ${plural(n, 'item', 'items')}`,
};

/** What the pill of `key` shows; null = no pill (zero, or not a count). */
export function badgeFacts(key, value) {
  const sentence = SENTENCES[key];
  const n = Number(value);
  if (!sentence || !Number.isFinite(n) || n <= 0) return null;
  return { count: n, tone: TONES[key] || 'neutral', title: sentence(n) };
}
